<h2 mat-dialog-title class="text-lg font-bold mb-1">  {{ isEditMode ? 'Editar Registro' : 'Nuevo Registro' }}</h2>
<mat-dialog-content class="modal-content">
  <form #createForm="ngForm" class="grid grid-cols-2 gap-4">
          <!-- ng-select for distribution-chain --> 
           <div [ngClass]="{'disabled': isEditMode}"  class="col-span-2">
            <label>Cadena de Distribución</label>
            <ng-select  
              [(ngModel)]="currentCreateBusinessPartnerChain.distributionChainId"
              [items]="distributionChainList"
              bindLabel="name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Seleccione un canal de distribución"
              name="distributionChainId"
              [appendTo]="'body'"
              required
              [disabled]="isEditMode"
            >
            </ng-select>
          </div>

      <div class="grid grid-cols-3 gap-4 col-span-2">
        <div class="col-span-1">
        <label>Lista de Precios</label>
        <ng-select
          [(ngModel)]="currentCreateBusinessPartnerChain.businessPartnerPriceListId"
          [items]="priceList"
          bindLabel="name"
          bindValue="_id"
          [searchable]="true"
          placeholder="Seleccione un precio "
          [appendTo]="'body'"
          name="businessPartnerPriceListId"
          required
          (ngModelChange)="filterAndSetAlternalPriceList()" 
        >
           <ng-template ng-label-tmp let-item="item">
            <span   class="uppercase" style="font-size: 11px;">
              <b>{{ item.code }} - </b> 
             {{ item.name }}</span
            >
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
             <b
              style="font-size: 9px;"
              >{{ item.code }}</b><br>
              <div  class="uppercase" style="font-size: 11px;">
             {{ item.name }}</div>
          </ng-template>
        </ng-select>
      </div>
      <div  class="col-span-1">
        <label>Lista de Descuentos</label>
        <ng-select
          [(ngModel)]="currentCreateBusinessPartnerChain.businessPartnerDiscountListId"
          [items]="discountList"
          bindLabel="name"
          bindValue="_id"
          [searchable]="true"
          [appendTo]="'body'"
          placeholder="Seleccione un precio de descuento"
          name="businessPartnerDiscountListId"
          (ngModelChange)="filterAndSetAlternalDiscountList()" 
        >
         <ng-template ng-label-tmp let-item="item">
            <span  class="uppercase" style="font-size: 11px;">
              <b>{{ item.code }} - </b> 
             {{ item.name }}</span
            >
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
             <b
              style="font-size: 9px;"
              >{{ item.code }}</b><br>
              <div  class="uppercase" style="font-size: 11px;">
             {{ item.name }}</div>
          </ng-template>
        </ng-select>
      </div>
      
      <div  class="col-span-1">
        <label>Lista de Promociones</label>
        <ng-select
          [(ngModel)]="currentCreateBusinessPartnerChain.businessPartnerGiftListId"
          [items]="giftList"
          bindLabel="name"
          bindValue="_id"
          [searchable]="true"
          [appendTo]="'body'"
          placeholder="Seleccione un precio de promoción"
          name="businessPartnerGiftListId"
          (ngModelChange)="filterAndSetAlternalGiftList()" 
        >
        <ng-template ng-label-tmp let-item="item">
            <span  class="uppercase" style="font-size: 11px;">
              <b>{{ item.code }} - </b> 
             {{ item.name }}</span
            >
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
             <b
              style="font-size: 9px;"
              >{{ item.code }}</b><br>
              <div class="uppercase" style="font-size: 11px;">
             {{ item.name }}</div>
          </ng-template>
        </ng-select>
      </div>
      
    </div>


      <mat-form-field appearance="fill" class="col-span-1">
        <mat-label for="group-select">Lista de Precios Alternativa</mat-label>
        <mat-select
          [formControl]="alternalPriceMultiCtrl"
          placeholder="Seleccione lista de precios"
          [multiple]="true"
        >
        <mat-select-trigger>
          {{alternalPriceMultiCtrl.value?.[0]?.name || ''}}
          @if ((alternalPriceMultiCtrl.value?.length || 0) > 1) {
          <span class="example-additional-selection">
            (+{{(alternalPriceMultiCtrl.value?.length || 0) - 1}} {{alternalPriceMultiCtrl.value?.length === 2 ? 'other' : 'others'}})
          </span>
          }
        </mat-select-trigger>
          <mat-option>
            <ngx-mat-select-search
              [showToggleAllCheckbox]="true"
              [toggleAllCheckboxIndeterminate]="isIndeterminate"
              [toggleAllCheckboxChecked]="isChecked"
              (toggleAll)="toggleSelectAll($event)"
              [formControl]="alternalPriceMultiFilterCtrl"
              [noEntriesFoundLabel]="'No se encontraron resultados'"
              [placeholderLabel]="'Buscar lista de precios...'"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option
            *ngFor="let alternalPrice of filteredalternalPrice | async"
            [value]="alternalPrice"
          >
            <div class="text-sm uppercase leading-tight">
              <div>
                <b class="f-10">{{ alternalPrice.code }}</b>
              </div>
              {{ alternalPrice.name }}
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>

       <mat-form-field appearance="fill" class="col-span-1">
        <mat-label for="group-select">Lista de Descuentos Alternativa</mat-label>
        <mat-select
          [formControl]="alternalDiscountMultiCtrl"
          placeholder="Seleccione lista de descuentos"
          [multiple]="true"
        >
          <mat-option>
            <ngx-mat-select-search
              [showToggleAllCheckbox]="true"
              [toggleAllCheckboxIndeterminate]="isIndeterminateDiscount"
              [toggleAllCheckboxChecked]="isCheckedDiscount"
              (toggleAll)="toggleSelectAllDiscount($event)"
              [formControl]="alternalDiscountMultiFilterCtrl"
              [noEntriesFoundLabel]="'No se encontraron resultados'"
              [placeholderLabel]="'Buscar lista de descuentos...'"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option
            *ngFor="let discountPrice of filteredalternalDiscount | async"
            [value]="discountPrice"
          >
            <b>{{ discountPrice?.code }}</b
            > -<br>{{ discountPrice.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

         <mat-form-field appearance="fill" class="col-span-1">
        <mat-label for="group-select">Lista de Promociones Alternativa</mat-label>
        <mat-select
          [formControl]="alternalGiftMultiCtrl"
          placeholder="Seleccione lista de promociones"
          [multiple]="true"
        >
          <mat-option>
            <ngx-mat-select-search
              [showToggleAllCheckbox]="true"
              [toggleAllCheckboxIndeterminate]="isIndeterminateGift"
              [toggleAllCheckboxChecked]="isCheckedGift"
              (toggleAll)="toggleSelectAllGift($event)"
              [formControl]="alternalGiftMultiFilterCtrl"
              [noEntriesFoundLabel]="'No se encontraron resultados'"
              [placeholderLabel]="'Buscar lista de promociones...'"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option
            *ngFor="let alternalGift of filteredalternalGift | async"
            [value]="alternalGift"
          >
            <b>{{ alternalGift?.code }} -</b
            ><br>{{ alternalGift.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="col-span-1">
        <mat-label>División</mat-label>
        <mat-select
          [(ngModel)]="currentCreateBusinessPartnerChain.divisionIds"
          name="divisionIds"
          multiple
        >
          <!-- Descomenta y usa si deseas incluir un buscador -->
          <!-- <mat-option>
            <ngx-mat-select-search
              [(ngModel)]="searchMaterialGroup"
              [ngModelOptions]="{ standalone: true }"
              placeholderLabel="Buscar..."
              noEntriesFoundLabel="No se encontraron resultados"
            >
            </ngx-mat-select-search>
          </mat-option> -->
          
          <mat-option *ngFor="let group of divisionList" [value]="group._id">
            <b *ngIf="group?.code">{{group.code}} - </b>{{group.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      

      <div  class="col-span-1">
        <label>Planta</label>
        <ng-select
          [(ngModel)]="currentCreateBusinessPartnerChain.plantId"
          [items]="plants"
          bindLabel="name"
          bindValue="_id"
          [searchable]="true"
          [appendTo]="'body'"
          placeholder="Selecciona una planta"
          (ngModelChange)="onPlantsSelectionChange($event)"
          [compareWith]="compareById"
          name="plantId"
        >
        <ng-template ng-label-tmp let-item="item">
          <span>{{item.name}}</span>
        </ng-template>
        </ng-select>
      </div>

      <div  class="col-span-1">
        <label>Almacén</label>
        <ng-select
          [(ngModel)]="currentCreateBusinessPartnerChain.warehouseId"
          [items]="warehouses"
          bindLabel="name"
          bindValue="_id"
          [searchable]="true"
          [appendTo]="'body'"
          placeholder="Selecciona un Almacen"
          (ngModelChange)="onWarehouseSelectionChange($event)"
          [compareWith]="compareById"
          name="warehouseId"
        >
        <ng-template ng-label-tmp let-item="item">
          <span>{{item.name}}</span>
        </ng-template>
        </ng-select>
      </div>

      <app-form-section *ngIf="fieldsMasterDataStatus" title="Campos de usuario" icon="business" iconColor="blue" class="col-span-2">
        <app-user-fields-configuration
          [fields]="fieldsMasterData"
          [model]="currentCreateBusinessPartnerChain"
        >
        </app-user-fields-configuration>
      </app-form-section>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="!createForm.valid"
    class="justify-end"
  >
  {{ isEditMode ? 'Actualizar' : 'Guardar' }}
  </button>
</mat-dialog-actions>
